import React, { useEffect, useState, useRef } from "react";
import { Layout, message } from "antd";
import SidebarAdmin from "../Sidebar/AdminSidebar";
import SidebarUser from "../Sidebar/UserSidebar";
import { useContext } from "react";
import { UserContext } from "../../App";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import "./style.css";
import PageLayout from "../PageLayout";
import { useSocket } from "../../Utils/Context/SocketContext";

const AppLayout = ({ contents, userType, userName, setUser }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const { Content } = Layout;
  const [pageName, setPageName] = useState("");
  const [arrow, setArrow] = useState(null);
  const [name, setName] = useState(userName);
  const path = useLocation();
  const locationPath = path.pathname;

  const soundRef = useRef(null);

  useEffect(() => {
    soundRef.current = new Audio("/sounds/notification_sound.mp3");
    soundRef.current.preload = "auto";
  }, []);

  useEffect(() => {
    const unlockAudio = () => {
      if (soundRef.current) {
        soundRef.current.muted = true;

        soundRef.current.play()
          .then(() => {
            soundRef.current.pause();
            soundRef.current.currentTime = 0;
            soundRef.current.muted = false;
          })
          .catch(() => { });

        document.removeEventListener("click", unlockAudio);
      }
    };

    document.addEventListener("click", unlockAudio);
  }, []);

  useEffect(() => {
    // Admin routes
    if (locationPath === "/all-users") {
      setPageName("All Users Accounts");
      setName(null);
      setArrow(false);
    } else if (locationPath.includes("/add-user")) {
      setPageName("Add New User");
      setName(null);
      setArrow(true);
    } else if (locationPath.includes("/view-user-details")) {
      setPageName("View User Details");
      setName(null);
      setArrow(true);
    } else if (locationPath === "/recovery-company") {
      setPageName("Recovery Companies List");
      setName(null);
      setArrow(false);
    } else if (locationPath.includes("/view-recovery-company/")) {
      setPageName("View Recovery Company");
      setName(null);
      setArrow(true);
    } else if (locationPath.includes("/add-recovery-company")) {
      setPageName("Add New Recovery Company");
      setName(null);
      setArrow(true);
    } else if (locationPath.includes("/theft-history")) {
      setPageName("Theft History");
      setName(null);
      setArrow(false);
    } else if (locationPath === "/api-accounts") {
      setPageName("API");
      setName(null);
      setArrow(false);
    } else if (locationPath === "/add-api-accounts") {
      setPageName("Add New API");
      setName(null);
      setArrow(true);
    } else if (locationPath === "/view-api-details") {
      setPageName("Edit API Details");
      setName(null);
      setArrow(true);
    } else if (locationPath.includes("/settings")) {
      setPageName("Admin Profile");
      setName(null);
      setArrow(false);
    }

    // User routes
    else if (locationPath.includes("/dashboard")) {
      setPageName("Welcome to");
      setName(userName);
      setArrow(false);
    } else if (locationPath.includes("/vehicle-status")) {
      setPageName("Vehicle Status");
      setName(null);
      setArrow(false);
    } else if (locationPath.includes("/offline-analysis")) {
      setPageName("Offline Analysis");
      setName(null);
      setArrow(false);
    } else if (locationPath === "/high-risk") {
      setPageName("High Risk Activities");
      setName(null);
      setArrow(false);
    } else if (locationPath.includes("/add-high-risk")) {
      setPageName("Add High-Risk Activity");
      setName(null);
      setArrow(true);
    } else if (locationPath.includes("/view-high-risk-detail")) {
      setPageName(path.state?.pageTitle ?? "High-Risk Activity Detail");
      setName(null);
      setArrow(true);
    } else if (locationPath.includes("/view-notification-detail")) {
      setPageName("Notification Detail");
      setName(null);
      setArrow(true);
    } else if (locationPath.includes("/theft")) {
      setPageName("Suspected Theft Log");
      setName(null);
      setArrow(false);
    } else if (locationPath.includes("/shut-down")) {
      setPageName("Shutdown Logs");
      setName(null);
      setArrow(false);
    } else if (locationPath === "/add-shutdown") {
      setPageName("Add Manual Shutdown Vehicle");
      setName(null);
      setArrow(true);
    } else if (locationPath.includes("/probability")) {
      setPageName("Theft Probability Meter");
      setName(null);
      setArrow(false);
    } else if (locationPath.includes("/calls")) {
      setPageName("Call Log");
      setName(null);
      setArrow(false);
    } else if (locationPath === "/geofences") {
      setPageName("Geofences");
      setName(null);
      setArrow(false);
    } else if (locationPath === "/add-geofences") {
      setPageName("Add New Geofence");
      setName(null);
      setArrow(true);
    } else if (locationPath === "/view-geofences") {
      setPageName("View / Edit Geofence");
      setName(null);
      setArrow(true);
    } else if (locationPath === "/customer-list") {
      setPageName("Customers");
      setName(null);
      setArrow(false);
    } else if (locationPath === "/add-vehicles") {
      setPageName("Add Vehicles");
      setName(null);
      setArrow(true);
    } else if (locationPath.startsWith("/view-customer-details")) {
      setPageName("Customer Details");
      setName(null);
      setArrow(true);
    } else if (locationPath === "/add-customer-list") {
      setPageName("Add New Customer");
      setName(null);
      setArrow(true);
    } else if (locationPath.includes("/notifications")) {
      setPageName("Notifications");
      setName(null);
      setArrow(false);
    } else if (locationPath.includes("/system-configuration")) {
      setPageName("System Configuration");
      setName(null);
      setArrow(false);
    } else if (locationPath.includes("/settings")) {
      setPageName("Admin Profile");
      setName(null);
      setArrow(false);
    }
  }, [locationPath, path.state]);

  const socket = useSocket();
  useEffect(() => {
    if (!socket) {
      console.log("Socket Instance not found")
      return;
    }

    const handleNotification = (payload) => {
      if (soundRef.current) {
        soundRef.current.currentTime = 0;
        soundRef.current.play().catch((err) => {
          console.log("Sound play blocked:", err);
        });
      }

      messageApi.open({
        type: "warning",
        content: (
          <div>
            <div style={{ fontWeight: 600, textAlign: "left" }}>
              {payload.title || "Theft Detected For Vehicle"}
            </div>
            {payload.subtitle && (
              <div style={{ fontSize: "12px", opacity: 0.7 }}>
                {payload.subtitle}
              </div>
            )}
          </div>
        ),
        duration: 5,
      });
    };

    socket.on("notification", handleNotification);

    return () => {
      socket.off("notification", handleNotification);
    };
  }, [socket]);


  return (
    <div className="app-layout">
      {contextHolder}
      <Layout style={{ minHeight: "100vh" }}>
        <>
          {userType === "user" ? (
            <SidebarUser setUser={setUser} breakpoint="md" />
          ) : (
            <SidebarAdmin setUser={setUser} breakpoint="md" />
          )}
        </>

        <Layout className="site-layout">
          <Content className="content">
            <PageLayout pageName={pageName} name={name} arrow={arrow}>
              {contents}
            </PageLayout>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default AppLayout;
